
import { formatCurrency } from "../../utils/monetary";
import { useDispatch } from "react-redux";
import { Table, Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { deletePeriod } from "../../store/actions/RentalPeriodAction";
import dayjs from "dayjs";

function TablePeriod({ loading, periods }) {
  const dispatch = useDispatch();

  const handleDelete = (id) => {
    dispatch(deletePeriod(id));
  };

  const columns = [
    {
      title: "Date de début",
      dataIndex: "start_at",
      key: "start_at",
      width: "30%",
      sorter: (a, b) => {
        // Convertir les dates DD/MM/YYYY en objets dayjs pour comparaison
        const dateA = dayjs(a.start_at, "DD/MM/YYYY");
        const dateB = dayjs(b.start_at, "DD/MM/YYYY");
        return dateA.valueOf() - dateB.valueOf();
      },
      defaultSortOrder: "descend",
    },
    {
      title: "Date de fin",
      dataIndex: "end_at",
      key: "end_at",
      width: "30%",
      sorter: (a, b) => {
        // Convertir les dates DD/MM/YYYY en objets dayjs pour comparaison
        const dateA = dayjs(a.end_at, "DD/MM/YYYY");
        const dateB = dayjs(b.end_at, "DD/MM/YYYY");
        return dateA.valueOf() - dateB.valueOf();
      },
    },
    {
      title: "Loyer propriétaire semaine",
      dataIndex: "amount",
      key: "amount",
      width: "30%",
      align: "right",
      render: (amount) => formatCurrency(amount),
    },
    {
      title: "",
      key: "action",
      width: "10%",
      align: "right",
      render: (_, record) => (
        <Popconfirm
          title="Supprimer cette période ?"
          description="Êtes-vous sûr de vouloir supprimer cette période ?"
          onConfirm={() => handleDelete(record.id)}
          okText="Oui"
          cancelText="Non"
          okButtonProps={{ danger: true }}
        >
          <Button
            type="default"
            icon={<DeleteOutlined />}
            size="middle"
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div style={{ marginBottom: 20 }}>
    <Table
      dataSource={periods || []}
      columns={columns}
      loading={loading}
      rowKey="id"
      pagination={false}
      locale={{
        emptyText: "Aucune période",
      }}
      size="large"
    />
    </div>
  );
}

export default TablePeriod;